/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createDot } from '../../factoriesAny.js';
export var dotDependencies = {
  addDependencies: addDependencies,
  multiplyDependencies: multiplyDependencies,
  typedDependencies: typedDependencies,
  createDot: createDot
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDot.generated.js
// module id = 1392
// module chunks = 0